export default {
  init() {
    // JavaScript to be fired on all pages

    $('.hamburger').click(function () {
      $(this).toggleClass('is-active');
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    var Header = {};

    Header.Scroll = function () {
      $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        if (scroll > 0) {
          $('header.banner').addClass('scrolled');
        }
        else {
          $('header.banner').removeClass('scrolled');
        }
      });
    }

    

    // Header.OnShowCollapse = function () {
    //   $( '#navbarTop' ).on( 'show.bs.collapse', function () {
    //     $( 'header.banner .navbar' ).addClass( 'megamenu-opened' );
    //   } )

    //   $( '#navbarTop' ).on( 'hide.bs.collapse', function () {
    //     $( 'header.banner .navbar' ).removeClass( 'megamenu-opened' );
    //   } )
    // }

    // Fire Functions
    Header.Scroll();
    //Header.OnShowCollapse();

    $('.testimony-slider').on('init', function () {

      // check to see if there are one or less slides
      if (!($('.testimony-slider .slick-slide').length > 1)) {

        // remove arrows
        $('.slick-dots').css('visibility', 'hidden');

      }

    });


    $(function () {
      $('.testimony-slider').slick({
        dots: true,
        fade: true,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        speed: 1000,
      });

      $('.equipe-slider').slick({
        //dots:  true,
        //fade: true,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        speed: 1300,
        infinite: true,
        mobileFirst: true,

        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ],

      });


    });



    // to top right away
    if (window.location.hash) scroll(0, 0);
    // void some browsers issue
    setTimeout(function () { scroll(0, 0); }, 1);

    $(function () {
      // *only* if we have anchor on the url
      if (window.location.hash) {
        // smooth scroll to the anchor id
        $('html, body').animate({
          scrollTop: $(window.location.hash).offset().top - 150,
        }, 1000, 'swing');
      }

    });

    // Select all links with hashes
    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .not('.nav-item')

      .click(function (event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
          &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top - 170,
            }, 1000, function () {

            });
          }
        }
      });



      $('#menu-top-menu a.dropdown-toggle').on('click',function (e) {

        console.log($(this));
        console.log($(this).data('href'));
        e.preventDefault();
        window.location.href = $(this).data('href');
      });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js